import { useRef } from "react";
import "../styles/output.css";
import { useNavigate } from "react-router-dom";
import Button from "../components/basicComponents/button";
import TextInput from "../components/basicComponents/text-input";
import arrowRight from "../assets/SVGs/arrow-right.svg";
import { useFormik } from "formik";
import { ReactComponent as EmailIcon } from "../assets/SVGs/mail.svg";
import { ReactComponent as LoginSvg } from "../assets/SVGs/login-svg.svg";
import theme from "../config/theme";
import { useSelector } from "react-redux";
import { RootState } from "../state-management/store";
import ToggleChangeTheme from "../components/toggle-change-theme";
import * as Icons from "../assets/SVGs/index";
import { forgotPasswordSchema } from "../utils/validation-schema";
import { resetPassword } from "../state-management/actions/reset-password-action";
import { useDispatch } from "react-redux";
import {
    setAlert,
    setAlertSeverity,
    setAlertContext,
} from "../state-management/actions/alerts-actions";

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const emailRef = useRef<any>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const navigate = useNavigate();

    // Get the current theme mode from the global state
    const themeMode = useSelector(
        (state: RootState) => state.globalState.theme
    );
    const mode = themeMode === "light" ? theme.light : theme.dark;

    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: forgotPasswordSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    email: values.email,
                };
                const response = await resetPassword(data)(dispatch);
                if (response.status === 200) {
                    dispatch(setAlert(true));
                    dispatch(setAlertSeverity("success"));
                    dispatch(setAlertContext("به ایمیل شما لینکی ارسال شد "));
                }
            } catch (error: any) {
                console.log(error); // Log error for debugging
            }
        },
    });

    return (
        <div
            className="w-full min-h-screen flex flex-col items-center justify-center"
            style={{ backgroundColor: mode.backgroundColor.bgPrimary }}
        >
            <div className="grid md:grid-cols-2 items-center max-w-4xl max-md:max-w-lg w-full m-4 shadow-[0_2px_10px_-3px_rgba(128,128,128,0.3)] rounded-lg border border-[#0e9f6e3d]">
                <div
                    className="md:h-full rounded-lg p-8 flex justify-center items-center hidden md:flex"
                    style={{ backgroundColor: mode.backgroundColor.bgGray }}
                >
                    <LoginSvg style={{ color: "green" }} />
                </div>
                <div className="md:max-w-full w-full md:p-14 p-5">
                    <div className="p-2 flex flex-col items-center justify-center">
                        <p
                            className="text-xl font-bold my-2"
                            style={{ color: mode.color.textPrimary }}
                        >
                            فراموشی رمز!{" "}
                        </p>
                        <p
                            className="my-3 w-full text-right"
                            style={{ color: mode.color.textSecondary }}
                        >
                            برای بازیابی رمز عبور ایمیل خود را در زیر وارد کنید
                        </p>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <TextInput
                            ref={emailRef}
                            name="email"
                            label="ایمیل"
                            placeholder="ایمیل خود را وارد کنید"
                            RightIcon={<EmailIcon />}
                            onSubmit={() => buttonRef.current?.focus()}
                            textAlign="left"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.email && formik.errors.email
                                    ? formik.errors.email
                                    : undefined
                            }
                        />
                        <Button
                            ref={buttonRef}
                            title="ثبت"
                            type="submit"
                            color="white"
                            backgroundColor="#2D667F"
                            paddingx="153px"
                            paddingy="10px"
                        />
                    </form>
                    <p
                        className="text-right cursor-pointer flex justify-start items-center w-full text-xs mt-4"
                        style={{ color: mode.color.textSuccess }}
                        onClick={() => navigate("/login-page")}
                    >
                        ورود به حساب
                        <img src={arrowRight} alt="arrow" />
                    </p>
                </div>
            </div>
            {/* Theme Toggle Switch */}
            <div className="w-full justify-center pb-2">
     <div className="flex justify-around mt-4">
                <ToggleChangeTheme
                    lightIcon={
                        <Icons.MoonIcon
                            fill="#000000"
                            className="absolute bottom-[6%] left-[0%] h-6 w-6 rounded-full bg-[#ffffff] transition-all duration-500 peer-checked:transform peer-checked:translate-x-full"
                        />
                    }
                    darkIcon={
                        <Icons.SunIcon
                            fill="#ffffff"
                            className="absolute bottom-[6%] left-[-20%] h-6 w-6 rounded-full bg-[#25282D] transition-all duration-500 peer-checked:transform peer-checked:translate-x-full"
                        />
                    }
                />
            </div>
     </div>
        </div>
    );
};

export default ForgotPassword;
